import { ApiPath, auditLogItemSchema } from '@app/shared';
import { apiList } from '../../lib/api';

export async function getAuditLogs(params?: {
  page?: number;
  limit?: number;
  aksi?: string;
  entitas?: string;
  pegawai_id?: number;
  tanggal_dari?: string;
  tanggal_sampai?: string;
  search?: string;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.ADMIN.AUDIT_LOG, auditLogItemSchema, params);
}
